<template>
	<div class="ci-categories">
		<header class="cat-head">
			<p class="cat-eyebrow">Clasificación</p>
			<h2 class="cat-title">Categorías</h2>
		</header>

		<div class="cat-grid">
			<section v-for="catType of categoryTypes" :key="catType.type" class="cat-block">
				<h3 class="cat-block__type">{{ catType.type }}</h3>

				<div class="cat-block__list">
					<template v-for="attrib of classifiedAttributes[catType.type]">
						<div v-if="attrib.name !== ''" :key="attrib.id" class="cat-item">
							<span v-if="updatedAttrib == null || updatedAttrib.id != attrib.id" class="cat-item__name">
								{{ attrib.name }}
							</span>

							<b-field v-if="updatedAttrib != null && updatedAttrib.id == attrib.id" class="cat-item__edit mb-0"
								:label="'Actualice ' + nameBeforeUpdate" :label-for="attrib.name">
								<Input :inputId="attrib.name" v-model="updatedAttrib.name" placeholder="" />
								<span class="cat-item__actions">
									<b-button class="ap-btn ap-btn--primary" icon-right="pencil-ruler"
										@click="() => addAttribute(catType.type, updatedAttrib.id)">
										Editar
									</b-button>
									<b-button class="ap-btn ap-btn--ghost" icon-right="minus"
										@click="() => editAttribute(null)">
										Cancelar
									</b-button>
								</span>
							</b-field>

							<span v-if="updatedAttrib == null || updatedAttrib.id != attrib.id" class="cat-item__actions">
								<b-button class="ap-btn ap-btn--ghost" icon-right="pencil-ruler"
									@click="() => editAttribute(attrib)">
									Editar
								</b-button>
								<b-button class="ap-btn ap-btn--danger" icon-right="trash"
									@click="() => deleteAttribute(attrib)">
									Eliminar
								</b-button>
							</span>
						</div>
					</template>
				</div>

				<div class="cat-block__add">
					<b-field class="mb-0" :label-for="catType.type">
						<Input :inputId="catType.type" v-model.lazy="auxInput[catType.type]" placeholder=""
							:disabled="updatedAttrib != null && updatedAttrib.type == catType.type" />
						<b-button class="ap-btn ap-btn--primary"
							:disabled="updatedAttrib != null && updatedAttrib.type == catType.type"
							@click="() => addAttribute(catType.type)">
							Agregar
						</b-button>
					</b-field>
				</div>
			</section>
		</div>
	</div>
</template>

<script>
import { mapActions } from "vuex";
import Input from "@/components/inputs/Input";
import { consoleHandlerError, notificate } from "@/utils/message";

export default {
	name: "CompanyInfoCategories",
	components: {
		Input,
	},
	props: {
		company_id: {
			type: [Number, String],
			default: null,
		},
	},
	data() {
		return {
			allAttributes: [],
			auxInput: {
				'linea de negocio': '',
				'canal': '',
				'proyecto': '',
				'tipo de producto': '',
				'otra categoría': '',
			},
			classifiedAttributes: {
				'linea de negocio': [],
				'canal': [],
				'proyecto': [],
				'tipo de producto': [],
			},
			updatedAttrib: null,
			nameBeforeUpdate: '',
		};
	},
	computed: {
		companyId() {
			return this.company_id || this.$route.query.companyId;
		},
		categoryTypes() {
			let objectTypes = [{
				type: 'linea de negocio'
			}, {
				type: 'canal'
			}, {
				type: 'proyecto'
			}, {
				type: 'tipo de producto'
			}]
			for (let iAttrib = 0; iAttrib < this.allAttributes.length; iAttrib++) {
				const category = this.allAttributes[iAttrib];
				if (objectTypes.some(oType => oType.type === category.type)) {
					continue
				}
				objectTypes.push({
					type: category.type,
				})
			}
			objectTypes.push({
				type: 'otra categoría'
			})
			return objectTypes
		},
	},
	mounted() {
		this.fetchAttributes(this.companyId).then((data) => {
			this.allAttributes.push(...data)
		}).then(() => {
			this.initClassifiedAttributes()
		})
	},
	methods: {
		...mapActions("analystCompany", [
			"addAttributes",
			"deleteAttributes",
			"fetchAttributes",
		]),
		addAttribute(attributeType, idUpdatedAttrib = null) {
			if (attributeType == 'otra categoría') {
				attributeType = this.auxInput[attributeType]
			}

			let attrib = {
				type: attributeType,
				name: this.auxInput[attributeType] || '',
				company_id: this.companyId,
			}

			if (idUpdatedAttrib) {
				attrib.id = idUpdatedAttrib
				attrib.name = attrib.name == '' ? this.updatedAttrib.name : attrib.name
			}

			if (attrib.name.includes('_') || attrib.name.includes(';') ||
				attrib.type.includes('_') || attrib.type.includes(';')) {
				notificate(
					`<strong>No ingresar los siguientes datos: ; _</strong>`,
					"is-danger is-light",
				);
				return
			}

			if (this.classifiedAttributes[attributeType]) {
				this.classifiedAttributes[attributeType].forEach(elem => {
					if (elem.name == '') {
						attrib.id = elem.id
						return
					}
				});
			}

			this.addAttributes(attrib).then((data) => {
				let msg = "Se agrego correctamente"
				const updated = this.allAttributes.find(att => att.id === data.id)
				if (updated) {
					updated.name = data.name
					msg = "Se actualizo correctamente"
				} else {
					this.allAttributes.push(data)
				}

				notificate(
					`<strong>${msg} a ${data.name || data.type}</strong>`,
					"is-success is-light"
				);
			}).catch((error) => {
				consoleHandlerError({ error, empty: false });
			}).finally(() => {
				this.cleanInputs()
				this.updatedAttrib = null
				this.initClassifiedAttributes()
			})
		},
		initClassifiedAttributes() {
			this.categoryTypes.forEach(oType => {
				this.classifiedAttributes[oType.type] = []
				this.auxInput[oType.type] = ''
			});
			this.allAttributes.forEach(attrib => {
				this.classifiedAttributes[attrib.type].push(attrib)
			});
		},
		editAttribute(attribute) {
			this.cleanInputs()
			if (attribute) {
				this.nameBeforeUpdate = attribute.name
				this.updatedAttrib = { ...attribute }
			} else {
				this.updatedAttrib.name = this.nameBeforeUpdate
				this.nameBeforeUpdate = ''
				this.updatedAttrib = null
			}
		},
		deleteAttribute(attrib) {
			this.deleteAttributes({
				attribute: attrib,
				companyId: this.companyId,
			}).then(({ status }) => {
				if (status == 204) {
					const iAttrib = this.allAttributes.indexOf(attrib)
					this.allAttributes.splice(iAttrib, 1)
					this.initClassifiedAttributes()
					notificate(
						`<strong>Se elimino correctamente a ${attrib.name}</strong>`,
						"is-success is-light"
					);
				} else {
					throw new Error("No se pudo eliminar");
				}
			}).catch((error) => {
				consoleHandlerError({ error, empty: true });
			})
		},
		cleanInputs() {
			Object.keys(this.auxInput).forEach(keyInput => {
				this.auxInput[keyInput] = ''
			});
			this.auxInput = { ...this.auxInput }
		}
	},
};
</script>

<style scoped lang="scss">
.ci-categories {
	font-family: var(--ap-font);
	color: var(--ap-ink-2);
}

.cat-head {
	margin-bottom: 20px;
}

.cat-eyebrow {
	margin: 0 0 4px;
	font-size: 11px;
	font-weight: 600;
	letter-spacing: 0.08em;
	text-transform: uppercase;
	color: var(--ap-muted);
}

.cat-title {
	margin: 0;
	font-size: 22px;
	font-weight: 700;
	color: var(--ap-ink);
}

.cat-grid {
	display: grid;
	grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
	gap: 18px;
}

.cat-block {
	background: var(--ap-mist);
	border: 1px solid var(--ap-line);
	border-radius: var(--ap-radius-sm);
	padding: 18px;
	display: flex;
	flex-direction: column;
	gap: 14px;
}

.cat-block__type {
	margin: 0;
	font-size: 15px;
	font-weight: 700;
	text-transform: capitalize;
	color: var(--ap-ink);
}

.cat-block__list {
	display: flex;
	flex-direction: column;
	gap: 8px;
}

.cat-item {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: 10px;
	flex-wrap: wrap;
	padding: 8px 12px;
	background: var(--ap-paper);
	border: 1px solid var(--ap-line);
	border-radius: var(--ap-radius-sm);
}

.cat-item__name {
	text-transform: capitalize;
	font-size: 14px;
	color: var(--ap-ink-2);
}

.cat-item__edit {
	flex: 1;
	min-width: 0;
}

.cat-item__actions {
	display: inline-flex;
	gap: 6px;
	align-items: center;
}

.cat-block__add {
	margin-top: auto;
	padding-top: 4px;
}

// Themed buttons — Buefy renders <b-button> as a native <button class="ap-btn …">,
// whose root receives this component's scope attribute, so no ::v-deep is needed here.
.ap-btn {
	display: inline-flex;
	align-items: center;
	gap: 6px;
	border: 1px solid transparent;
	border-radius: var(--ap-radius-pill);
	padding: 6px 14px;
	height: auto;
	font-family: var(--ap-font);
	font-size: 13px;
	font-weight: 600;
	line-height: 1.2;
	cursor: pointer;
	transition: background-color 0.18s var(--ap-ease),
		color 0.18s var(--ap-ease),
		border-color 0.18s var(--ap-ease),
		transform 0.18s var(--ap-ease),
		box-shadow 0.18s var(--ap-ease);

	&:hover:not([disabled]) {
		transform: translateY(-1px);
	}

	&:focus-visible {
		outline: 2px solid var(--ap-teal);
		outline-offset: 2px;
	}

	&[disabled] {
		opacity: 0.5;
		cursor: not-allowed;
	}
}

.ap-btn--primary {
	background: var(--ap-ink);
	color: var(--ap-paper);

	&:hover:not([disabled]) {
		background: var(--ap-teal-deep);
	}
}

.ap-btn--ghost {
	background: var(--ap-paper);
	border-color: var(--ap-line-strong);
	color: var(--ap-ink-2);

	&:hover:not([disabled]) {
		border-color: var(--ap-teal);
		color: var(--ap-teal-deep);
	}
}

.ap-btn--danger {
	background: var(--ap-alert-wash);
	color: var(--ap-alert);

	&:hover:not([disabled]) {
		background: var(--ap-alert);
		color: var(--ap-paper);
	}
}

// Input focus ring — the <Input> child's <input> is a descendant, needs ::v-deep.
:deep(.input){
	border-radius: var(--ap-radius-sm);
	border: 1px solid var(--ap-line-strong);
	transition: border-color 0.18s var(--ap-ease), box-shadow 0.18s var(--ap-ease);

	&:focus,
	&:focus-within {
		border-color: var(--ap-teal);
		box-shadow: 0 0 0 3px var(--ap-teal-wash);
	}
}
</style>
